export const BRAND_KEY = 'kenwood'
export const BRAND_LABEL = 'Kenwood'
export const BRAND_SHORT_LABEL = 'KW'
export const BRAND_CODE_MARKETING_CLOUD = 'ken'
export const BRAND_INFO = {
    key: BRAND_KEY,
    label: BRAND_LABEL,
    short_label: BRAND_SHORT_LABEL,
}
export const BRAND_KEY_FILTER_CS = BRAND_KEY
export const DEFAULT_SITE = 'kenwood-eu'
export const MAIN_DOMAIN = 'kenwoodworld.com'
